import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DRAG_AND_DROP_STATE_ACTION } from '../../../features/analyses/Freeform/FreeformAnalysisForm/FreeformAnalysisFormUtil/dragAndDropReducer';
import {
  getLibraryItem,
  getLibraryItemPosition,
  getReportFormatLayoutState,
  setLibraryItemFinishPosition,
  setLibraryItemStartPosition,
} from '../../redux/reportFormat/reportFormatSlice';
import EditSectionLayout from './EditSectionLayout';
import { useSections } from './SectionContext';

const SectionLayoutContainer = ({
  onDragStart,
  onDragUpdate,
  onDragEnd,
  libraryItemMap,
  droppableLocations,
  onAddNewSection,
  setDroppableLocations,
  loading = false,
}) => {
  // local states
  // const [analysisData, setAnalysisData] = useState();

  const dispatch = useDispatch();
  const { showRightPanel2 } = useSelector(getReportFormatLayoutState);

  // contexts
  // const { projectId, analysisId } = useParams();
  const [, contextDispatch] = useSections();
  const { start: source, finish: destination } = useSelector(
    getLibraryItemPosition
  );
  const { draggableId } = useSelector(getLibraryItem);

  const removeItemFromColumn = (column, index) => {
    const startItemIds = Array.from(column.libraryItemIds);
    startItemIds.splice(index, 1);
    return {
      ...column,
      libraryItemIds: startItemIds,
    };
  };

  const insertItemIntoColumn = (column, index, itemId) => {
    const newItemIds = Array.from(column.libraryItemIds);
    newItemIds.splice(index, 0, itemId);
    return {
      ...column,
      libraryItemIds: newItemIds,
    };
  };

  const handleKeyDownEnd = useCallback(() => {
    const start = droppableLocations[source.droppableId];
    const finish = droppableLocations[destination.droppableId];

    if (finish.libraryItemIds.includes(draggableId)) {
      return;
    }

    const updatedStart = removeItemFromColumn(start, source.index);
    const updatedFinish = insertItemIntoColumn(
      finish,
      destination.index,
      draggableId
    );

    const newDroppableLocations = {
      ...droppableLocations,
      [updatedStart.id]: updatedStart,
      [updatedFinish.id]: updatedFinish,
    };

    setDroppableLocations(newDroppableLocations);
    dispatch(setLibraryItemStartPosition({ start: null, draggableId: null }));
    dispatch(setLibraryItemFinishPosition({ finish: null }));

    const newAnalysisColumn = finish.position;
    contextDispatch({
      type: DRAG_AND_DROP_STATE_ACTION.ITEM_MOVED_TO_ADJACENT_AREA,
      payload: {
        newAnalysisColumn,
        libraryItemId: draggableId,
      },
    });
  }, [
    source,
    destination,
    draggableId,
    droppableLocations,
    setDroppableLocations,
    dispatch,
    contextDispatch,
  ]);

  useEffect(() => {
    if (source && destination && draggableId) {
      handleKeyDownEnd();
    }
  }, [source, destination, draggableId, handleKeyDownEnd]);

  return (
    <div data-testid="add-report-data-layout-container">
      <EditSectionLayout
        showRightPanel={showRightPanel2}
        libraryItemMap={libraryItemMap}
        droppableLocations={droppableLocations}
        onAddNewSection={onAddNewSection}
        setDroppableLocations={setDroppableLocations}
        onDragStart={onDragStart}
        onDragUpdate={onDragUpdate}
        onDragEnd={onDragEnd}
        loading={loading}
      />
    </div>
  );
};

export default SectionLayoutContainer;
